import { Route, Routes } from "react-router-dom";

import { useGetProfile } from "../libs/api/react-query";

import PrivateRoute from "./PrivateRoute";

import {
  PermissionsAction,
  PermissionsPosModule,
  PermissionsScope
} from "@/common/types/permissions.types";
import ListTerms from "@/modules/Terms";
import { ViewTerm } from "@/modules/Terms/pages/view-terms";

function MembershipAssociationRoute(): JSX.Element {
  const userProfileQuery = useGetProfile();
  const permissions = userProfileQuery.data?.data?.role.permissions || [];

  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.TERMS}
            action={PermissionsAction.LIST}
          >
            <ListTerms title="Fichas de Matrícula" />
          </PrivateRoute>
        }
      />

      <Route
        path=":id"
        element={
          <PrivateRoute
            permissionScope={permissions[PermissionsScope.POS]}
            module={PermissionsPosModule.TERMS}
            action={PermissionsAction.READ}
          >
            <ViewTerm />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default MembershipAssociationRoute;
